import api from '../services/api';

export const logisticsOpsApi = {
  listCatalog: (params?: { status?: string; q?: string; barcode?: string }) =>
    api.get('/product-catalog', { params }).then((r) => r.data),

  createProduct: (body: {
    barcodes: { type: string; value: string }[];
    description?: string;
    manufacturer?: string;
  }) => api.post('/product-catalog', body).then((r) => r.data),

  updateProduct: (id: string, patch: { description?: string; status?: string }) =>
    api.patch(`/product-catalog/${id}`, patch).then((r) => r.data),

  importCatalog: (products: any[]) =>
    api.post('/product-catalog/import', { products }).then((r) => r.data),

  listCommissioned: (params?: {
    objectType?: string;
    status?: string;
    gtin?: string;
    since?: string;
  }) =>
    api
      .get('/inventory', { params: { source: 'RFID', ...(params || {}) } })
      .then((r) => r.data),

  getTraceability: (epc: string) => api.get(`/traceability/${epc}`).then((r) => r.data),

  rebuildTraceability: (epc: string) =>
    api.post(`/traceability/${epc}/rebuild`).then((r) => r.data),

  listVerificationDocs: () => api.get('/verification/documents').then((r) => r.data),

  importVerificationDoc: (body: {
    name: string;
    operationType: string;
    lines: { productCode: string; expectedQty: number }[];
  }) => api.post('/verification/documents', body).then((r) => r.data),

  getVerificationSession: (id: string) =>
    api.get(`/verification/sessions/${id}`).then((r) => r.data),

  getFeatureConfig: () => api.get('/features/config').then((r) => r.data),
};
